import { NavLink, Navigate, Route, Routes } from 'react-router-dom';
import { useMe } from '../../api/queries';
import { t } from '../../i18n/pt-BR';
import { CalendarioTab } from './CalendarioTab';
import { CapacidadeTab } from './CapacidadeTab';
import { LarguraMaeTab } from './LarguraMaeTab';
import { MaquinasTab } from './MaquinasTab';
import { SetupTab } from './SetupTab';
import { TiposTrocaTab } from './TiposTrocaTab';
import { TurnosTab } from './TurnosTab';

const TABS = [
  { path: 'maquinas', label: t.cadastros.tabs.machines },
  { path: 'turnos', label: t.cadastros.tabs.shifts },
  { path: 'capacidade', label: t.cadastros.tabs.capacity },
  { path: 'largura-mae', label: t.cadastros.tabs.motherWidths },
  { path: 'tipo-troca', label: t.cadastros.tabs.changeoverTypes },
  { path: 'setup', label: t.cadastros.tabs.setup },
  { path: 'calendario', label: t.cadastros.tabs.calendar },
] as const;

/** Cadastros: sub-abas por rota (`/cadastros/maquinas`…). Só o planejador edita. */
export function CadastrosPage() {
  const { data: me } = useMe();
  const canEdit = me?.perfil === 'planner' || me?.perfil === 'admin';

  return (
    <>
      <nav className="subtabs" aria-label={t.cadastros.title}>
        {TABS.map((tab) => (
          <NavLink key={tab.path} to={`/cadastros/${tab.path}`}>
            {tab.label}
          </NavLink>
        ))}
      </nav>
      {!canEdit ? (
        <div className="banner info" role="note">
          {t.cadastros.readOnlyHint}
        </div>
      ) : null}
      <Routes>
        <Route index element={<Navigate to="maquinas" replace />} />
        <Route path="maquinas" element={<MaquinasTab canEdit={canEdit} />} />
        <Route path="turnos" element={<TurnosTab canEdit={canEdit} />} />
        <Route path="capacidade" element={<CapacidadeTab canEdit={canEdit} />} />
        <Route path="largura-mae" element={<LarguraMaeTab canEdit={canEdit} />} />
        <Route path="tipo-troca" element={<TiposTrocaTab canEdit={canEdit} />} />
        <Route path="setup" element={<SetupTab canEdit={canEdit} />} />
        <Route path="calendario" element={<CalendarioTab canEdit={canEdit} />} />
        <Route path="*" element={<Navigate to="maquinas" replace />} />
      </Routes>
    </>
  );
}
